function MainFinancas() {
	return (
		<>
			<h1 className="mt-page"></h1>
		</>
	);
}

export default MainFinancas;
